export default __webpack_public_path__ + "f34b3b07326b5cc6754614560fbc64f4.png";